import Vue from 'vue';
import Vuex, {Store} from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {DevisElementsList} from '@/models';
import {DevisElementsListService} from "@/xhttp/DevisElementsListService";

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class DevisElementsListFilter {

	name: string = '';
	email: string = '';
	remarques: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';
	country: string = '';

	public clear(): void {
		this.name = '';
		this.email = '';
		this.remarques = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
		this.country = '';
	}

	public toString(): string {
		return JSON.stringify(this);
	}
}

class DevisElementsListState extends PaginatorFilterState<DevisElementsListFilter> {
	devisElementsList: DevisElementsList = null;
	devisElementsLists: ResultType<DevisElementsList> = null;
	public constructor() {
		super(new DevisElementsListFilter(), 'devisElementsLists', 'devisElementsList', 'id', AscDesc.DESC, 20)
	}
}

class DevisElementsListStore {

	@XHTTPService(() => DevisElementsList)
	private devisElementsListService: DevisElementsListService;
	private  _store: Store<any>;

	public state: DevisElementsListState = new DevisElementsListState();

	public mutations = {
		...PaginatorMutation(() => this._store, 'devisElementsLists', 'devisElementsList'),
	};

	public actions = {
		...StandardAction<DevisElementsList, DevisElementsListState>(() => DevisElementsList, 'devisElementsList'),
		...PaginatorActionWithFilters<DevisElementsList, DevisElementsListState>(() => DevisElementsList, 'devisElementsLists', 'devisElementsList'),
	};

	public init(store: Store<any>): this {
		this._store = store;
		return this;
	}

}

const instance = new DevisElementsListStore();
const storeDevisElementsList = new Vuex.Store(instance);
instance.init(storeDevisElementsList);

const instancePrix = new DevisElementsListStore();
export const storeDevisElementsListPrix = new Vuex.Store(instancePrix);
instancePrix.init(storeDevisElementsListPrix);

store.registerModule('devisElementsList', storeDevisElementsList);
store.registerModule('devisElementsListPrix', storeDevisElementsListPrix);
export default storeDevisElementsList;